import * as Cluster from '@flowmap.gl/cluster';
import { t } from '@lingui/macro';
import { getFlowDestId, getFlowMagnitude, getFlowOriginId, getLocationCentroid, getLocationId } from './commonGetters';

export const getClusterIndex = (locations, flows) => {
    const validLocations = locations.filter(loc => loc &&
        getLocationId(loc) &&
        getLocationCentroid(loc) !== null);
    const validLocationsById = Object.fromEntries(validLocations.map(loc => [ getLocationId(loc), loc ]));
    const validFlows = flows.filter(flow => flow &&
        getFlowOriginId(flow) &&
        getFlowDestId(flow) &&
        validLocationsById[getFlowOriginId(flow)] &&
        validLocationsById[getFlowDestId(flow)]
    );
    const getLocationWeight = Cluster.makeLocationWeightGetter(
        validFlows,
        {
            getFlowOriginId,
            getFlowDestId,
            getFlowMagnitude,
        }
    );
    const clusterLevels = Cluster.clusterLocations(
        validLocations,
        {
            getLocationId,
            getLocationCentroid,
        },
        getLocationWeight,
        {
            maxZoom: 20,
        }
    );
    const clusterIndex = Cluster.buildIndex(clusterLevels);
    const locationsById = validLocationsById;
    const getName = id => {
        const loc = locationsById[id];

        if (loc) {
            return loc.name || loc.id || id;
        }

        return `#${id}`;
    };

    for (const level of clusterLevels) {
        for (const node of level.nodes) {
            if (Cluster.isCluster(node)) {
                const leaves = clusterIndex.expandCluster(node);
                const topId = leaves.reduce((m, d) => !m || getLocationWeight(d) > getLocationWeight(m) ? d : m);
                const otherId = leaves.length === 2 && leaves.find(id => id !== topId);
                node.name = otherId ?
                    t({
                        id: '{topId} и {otherId}',
                        values: {
                            topId: getName(topId),
                            otherId: getName(otherId),
                        },
                    }) :
                    t({
                        id: '{topId} и {otherCount} других',
                        values: {
                            topId: getName(topId),
                            otherCount: leaves.length - 1,
                        },
                    });
            } else {
                node.name = getName(node.id);
            }
        }
    }

    return clusterIndex;
};
